import React, { useEffect, useState } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";

import {
  Button as MuiButton,
  Grid,
  TextField as MuiTextField,
} from "@material-ui/core";
import styled from "styled-components/macro";

import { spacing } from "@material-ui/system";

const TextField = styled(MuiTextField)(spacing);

const Button = styled(MuiButton)(spacing);

function AgentForm({ data, handleSubmit }) {
  const [name, setName] = useState("");
  const [instructions, setInstructions] = useState("");

  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    setName(data?.name || "");
    setInstructions(data?.instructions || "");
  }, [data]);

  const handleChange = (setInput, value) => {
    setInput(value);
  };

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    const form = {
      name,
      instructions,
    };
    try {
      await handleSubmit(form);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting ? (
        <CircularProgress variant="indeterminate" color="red" />
      ) : (
        <form>
          <Grid container spacing={6}>
            <Grid item md={12}>
              <TextField
                label="Nome do Agente"
                variant="outlined"
                fullWidth
                disabled
                value={name}
                my={2}
              />
            </Grid>
            <Grid item md={12}>
              <TextField
                label="Instruções"
                variant="outlined"
                fullWidth
                multiline
                rows={32}
                value={instructions}
                onChange={(e) => handleChange(setInstructions, e.target.value)}
                my={2}
              />
            </Grid>
          </Grid>

          <Button
            variant="contained"
            color="primary"
            mt={3}
            fullWidth
            onClick={submitForm}
          >
            {data.id ? "Atualizar" : "Cadastrar"}
          </Button>
        </form>
      )}
    </>
  );
}

export default AgentForm;
